import {
  APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION,
  APPLICATION_ADD_PROCESS_DATACOLLECTION,
  APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP,
  APPLICATION_SELECT_DATACOLLECTION,
  APPLICATION_SELECT_DATACOLLECTIONGROUP,
  APPLICATION_SET_ACTIVE_PROPOSAL,
  APPLICATION_SET_ACTIVE_SESSION,
  APPLICATION_UNSELECT_DATACOLLECTION,
  APPLICATION_UNSELECT_DATACOLLECTIONGROUP,
} from '../constants/ActionTypes'

export function setActiveProposal(proposal, title) {
  return {
    type: APPLICATION_SET_ACTIVE_PROPOSAL,
    payload: { name: proposal, title: title },
  }
}

export function setActiveSession(sessionId, title) {
  return {
    type: APPLICATION_SET_ACTIVE_SESSION,
    payload: { sessionId: sessionId, title: title },
  }
}

/**
 * Adds a data collection group to  the current selection
 * @param {dataColelction} dataCollectionGroup object
 */
export function selectDataCollectionGroup(dataCollectionGroup) {
  return {
    type: APPLICATION_SELECT_DATACOLLECTIONGROUP,
    payload: { dataCollection: dataCollectionGroup },
  }
}

/**
 * Removes a data collection group from selection
 * @param {dataColelction} dataCollectionGroup object
 */
export function unselectDataCollectionGroup(dataCollection) {
  return {
    type: APPLICATION_UNSELECT_DATACOLLECTIONGROUP,
    payload: { dataCollection: dataCollection },
  }
}

/**
 * Adds a data collection to  the current selection
 * @param {dataColelction} dataCollection object
 */
export function selectDataCollection(dataCollection) {
  return {
    type: APPLICATION_SELECT_DATACOLLECTION,
    payload: { dataCollection: dataCollection },
  }
}

/**
 * Removes a data collection from selection
 * @param {dataColelction} dataCollection object
 */
export function unselectDataCollection(dataCollection) {
  return {
    type: APPLICATION_UNSELECT_DATACOLLECTION,
    payload: { dataCollection: dataCollection },
  }
}

export function processDataCollectionGroup(dataCollectiongroup) {
  return {
    type: APPLICATION_ADD_PROCESS_DATACOLLECTIONGROUP,
    payload: { dataCollectiongroup: dataCollectiongroup },
  }
}

export function processDataCollection(dataCollection) {
  return {
    type: APPLICATION_ADD_PROCESS_DATACOLLECTION,
    payload: { dataCollection: dataCollection },
  }
}

export function processAutoprocintegration(autoprocintegration) {
  return {
    type: APPLICATION_ADD_PROCESS_AUTOPROCINTEGRATION,
    payload: { dataCollection: autoprocintegration },
  }
}
